import { render } from "./TablaInvitados.vue?vue&type=template&id=3eb79886&scoped=true"
import script from "./TablaInvitados.vue?vue&type=script&lang=js"
export * from "./TablaInvitados.vue?vue&type=script&lang=js"

import "./TablaInvitados.vue?vue&type=style&index=0&id=3eb79886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb79886"]])

export default __exports__